<div class="row">
    <div class="col-12" style="margin: 25px; width: 98%;">
        <div class="col-4">
            <button mat-flat-button color="primary" (click)="showData()">
                <div class="flex align-item-center"> {{'criteria' | translate}} </div>
            </button>


        </div>
        @if(showCriteria){
        <ng-content></ng-content>
        }
    </div>
</div>